import { Box, Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper"
import { PropsRight } from "./types"
import { DestinationType } from "../../../create/enums/destinationType"
import { InputModal } from "../../../create/components/inputModal"
import { CustomTable } from "../../../../../../../../../../components"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { icons } from "../../../../../../../../../../utils/icons"
import React, { useEffect, useState } from "react"
import { CaptionKey } from "../../../../../../../../../../components/detailKeyValue/keyCaption.index"
import { ListTooltipDetail } from "../../../../../../../../../../components/listTooltipDetail"
import { MapActivity } from "../../../../../mapActivity"
import { Roles } from "../../../../../../../../../../utils/enums"
import { Local } from "../../../create/types"
import { getLocalStorage } from "../../../../../../../../../../utils/crud/crypt"


const Right = React.memo((props: PropsRight) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const [openUnityModal, setOpenUnityModal] = useState(false)
    const [openDestinatioModal, setOpenDestinatioModal] = useState(false)
    const [openUserModal, setOpenUserModal] = useState(false)
    const [selectedPoint, setSelectedPoint] = useState<{ lat: number; lng: number } | null>(null);
    const [value, setValue] = useState('')
    const company: Local = getLocalStorage()
    //const disableDestinationForm = useMemo(() => generalDisabled(props.inputDestination, props.dataDestination), [props.dataDestination])
    const [disableName, setDisableName] = useState(false)
    const closeModal = () => {
        setOpenUnityModal(false)
        setOpenDestinatioModal(false)
        setOpenUserModal(false)
        props.filterUnity.cleanFilter()
    }

    const handleMapClick = (lat: number, lng: number) => {
        setSelectedPoint({ lat, lng });
    };

    const handleCloseUnity = () => {
        closeModal()
        props.setUnityToDestination()
        props.setEdit(true)
    }

    const handleSetDestination = () => {
        props.setDestinationFinal({
            id: null,
            latitude: selectedPoint?.lat ?? 0,
            longitude: selectedPoint?.lng ?? 0,
            name: /* String(props.dataDestination.title) */value,
            type: DestinationType.DESTINATION
        })
        closeModal()
        props.setEdit(true)
    }

    const handleSetUser = () => {
        props.setUserToFinal()
        closeModal()
    }

    const handleEditUnity = () => {
        setOpenUnityModal(true);
        props.setDestination(props.destinationFinal)
        props.filterUnity.cleanFilter()
        if (company.role !== Roles.ADMIN) {
            props.filterUnity.onChange({ target: { name: 'onlyHierarchy', value: true } })
        }
        props.setOldTypeDestination(DestinationType.DESTINATION)
    }

    const handleEditDestination = (create: boolean) => {
        setOpenDestinatioModal(true);
        if (create) {
            //props.handleDataDestination({})
            setValue('')
            setSelectedPoint(null)
            props.setOldTypeDestination(DestinationType.UNITY)
        } else {
            props.setOldTypeDestination(DestinationType.DESTINATION)
        }
    }

    const handleEditUser = () => {
        setOpenUserModal(true);
        props.setUser(props.userFinal)
        /* props.setDestination(props.destinationFinal) */
        props.filter.cleanFilter()
    }

    /* setSelectedPlace */

    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        if (place?.geometry?.location) {
            setSelectedPoint({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
        }
    };

    useEffect(() => {
        if (props.destinationFinal?.type == DestinationType.DESTINATION) {
            //props.handleDataDestination({ title: props.destinationFinal.name })
            setValue(props.destinationFinal.name)
            setSelectedPoint({ lat: props.destinationFinal.latitude, lng: props.destinationFinal.longitude })
        }
    }, [props.destinationFinal])

    return (
        <Box sx={styles.body}>
            {!props.isPartner &&
                <Box sx={styles.child}>
                    <Typography variant="title_grey_dark">{t('loogbook.titles.userRequired')}</Typography>

                    <Box>
                        <CustomPaper sx={styles.userContainer} elevation={3}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <CaptionKey value={t('general.tags.name')} caption={props.userFinal?.name} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    {/* <Typography className="bold">{t('general.tags.role')}</Typography>
                            <Typography>{props.userFinal?.role}</Typography> */}
                                    <CaptionKey value={t('general.tags.role')} caption={props.userFinal?.role ?? 'N/A'} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    {/* <Typography className="bold">{t('general.tags.division')}</Typography>
                            <Typography>{props.userFinal?.division ? props.userFinal?.division : 'N/A'}</Typography> */}
                                    <CaptionKey value={t('general.tags.division')} caption={props.userFinal?.division ?? 'N/A'} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    {/* <Typography className="bold">{t('general.tags.area')}</Typography>
                            <ListTooltipDetail list={props.userFinal?.area ?? []} /> */}
                                    <CaptionKey value={t('general.tags.area')} caption={<ListTooltipDetail list={props.userFinal?.area || []} />} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    {/* <Typography className="bold">{t('general.tags.department')}</Typography>
                            <ListTooltipDetail list={props.userFinal?.department ?? []} /> */}
                                    <CaptionKey value={t('general.tags.department')} caption={<ListTooltipDetail list={props.userFinal?.department || []} />} />
                                </Grid>
                            </Grid>

                        </CustomPaper>
                        <Button onClick={handleEditUser}>{t('loogbook.titles.changeUser')}</Button>
                    </Box>
                </Box>
            }

            <Box sx={styles.child}>
                <Typography variant="title_grey_dark">{t('loogbook.titles.destinationRequired')}</Typography>

                <Box>
                    <CustomPaper sx={styles.destinationContainer} elevation={3}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                                {/* <Typography className="bold">{t('general.tags.title')}</Typography>
                                <Typography>{props.destinationFinal?.name}</Typography> */}
                                <CaptionKey value={t('general.tags.title')} caption={props.destinationFinal?.name ?? 'N/A'} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                {/* <Typography className="bold">{t('general.tags.latitude')}</Typography>
                                <Typography>{props.destinationFinal?.latitude}</Typography> */}
                                <CaptionKey value={t('general.tags.latitude')} caption={String(props.destinationFinal?.latitude) ?? 'N/A'} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                {/* <Typography className="bold">{t('general.tags.longitude')}</Typography>
                                <Typography>{props.destinationFinal?.longitude}</Typography> */}
                                <CaptionKey value={t('general.tags.longitude')} caption={String(props.destinationFinal?.longitude) ?? 'N/A'} />
                            </Grid>
                        </Grid>
                    </CustomPaper>

                    <Box sx={styles.buttonWithoutBorder}>
                        <Button
                            onClick={() => {
                                if (props.destinationFinal) {
                                    props.destinationFinal.type === DestinationType.DESTINATION
                                        ? handleEditDestination(false)
                                        : handleEditUnity();
                                } else {

                                }
                            }}
                        >
                            {props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.buttons.editDestination') : t('loogbook.buttons.editUnity')}
                        </Button>
                        <Button
                            onClick={() => {
                                if (props.destinationFinal) {
                                    props.destinationFinal.type === DestinationType.UNITY
                                        ? handleEditDestination(true)
                                        : handleEditUnity()
                                } else {

                                }
                            }}
                        >{props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.buttons.selectUnity') : t('loogbook.buttons.createDestination')}</Button>
                    </Box>
                </Box>
            </Box>

            <InputModal
                open={openUnityModal}
                title={t('stores.filter.inputs.search')}
                cancelText={t('general.cancel')}
                buttonText={t('loogbook.buttons.select')}
                disableButton={!props.destination}
                back={closeModal}
                next={handleCloseUnity}
                children={<>
                    <Box sx={styles.filters}>
                        {!!props.filterUnity.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filterUnity.cleanFilter() } }} />)}
                        <DinamicForm input={Object.values(props.inputFilterUnity)} values={props.filterUnity.filterData} onChange={props.filterUnity.onChange} />
                    </Box>

                    <Box sx={styles.table({ row: !!props.tableUnits.row.length })}>
                        <CustomTable
                            name={'Table'}
                            tableRadio
                            tableChecks
                            dontRefresh
                            column={props.tableUnits.column}
                            defaultChecks={[Number(props.destination?.id)]}
                            row={props.tableUnits.row}
                            onClick={(e) => { props.handleRowClickUnity(e.checks[0]); }}
                            selected={-1}
                            loader={props.loading.units}
                            serverSidePagination={{ page: props.filterUnity.paginationModel.page + 1, size: props.filterUnity.paginationModel.pageSize, totalPages: props.totalPages }}
                            handleChange={(page: number, pageSize: number) => {
                                props.filterUnity.handlePagination({ page, pageSize })
                            }}
                        />
                    </Box>
                </>}
            />

            <InputModal
                open={openDestinatioModal}
                title={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                cancelText={t('general.cancel')}
                buttonText={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                back={closeModal}
                next={handleSetDestination}
                disableButton={disableName || !selectedPoint}
                children={<>
                    {/* <Box sx={styles.filters}>
                        <DinamicForm input={Object.values(props.inputDestination)} values={props.dataDestination} onChange={props.onChangeDestination} />
                    </Box> */}
                    <Box sx={styles.map}>
                        <MapActivity
                            defaultCenter={{ lat: selectedPoint ? selectedPoint.lat : 37.7749, lng: selectedPoint ? selectedPoint.lng : -122.4194 }}
                            defaultZoom={14}
                            selectedPoint={selectedPoint}
                            onMapClick={handleMapClick}
                            onPlaceSelect={handlePlaceSelect}
                            setDisableName={setDisableName}
                            value={value}
                            setValue={setValue}
                        />
                    </Box>
                </>
                }
            />

            <InputModal
                open={openUserModal}
                title={t('loogbook.titles.changeUser')}
                cancelText={t('general.cancel')}
                buttonText={t('general.save')}
                back={closeModal}
                next={handleSetUser}
                disableButton={!props.user}
                children={<>
                    <Box sx={styles.filters}>
                        {!!props.filter.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filter.cleanFilter() } }} />)}
                        <DinamicForm input={Object.values(props.inputFilter)} values={props.filter.filterData} onChange={props.filter.onChange} />
                    </Box>

                    <Box sx={styles.table({ row: !!props.tableUsers.row.length })}>
                        <CustomTable
                            name={'Table'}
                            dontRefresh
                            tableChecks
                            loader={props.loading.users}
                            column={props.tableUsers.column}
                            row={props.tableUsers.row}
                            onClick={(e) => { props.handleRowClickUser(e.checks[0]); }}
                            defaultChecks={[Number(props.user?.id)]}
                            selected={-1}
                            tableRadio={true}
                        />
                    </Box>
                </>
                }
            />
        </Box>
    )
})

export { Right }